import React from "react";

const InputError = props => {
  return (
    <div className="error_block">
      {props.icon && <div className="icon" />}
      <div className="error_msg">
        <span>{props.label}.</span>
      </div>
    </div>
  );
};

InputError.defaultProps = {
  icon: true
};
export default InputError;
